<template>
    <footer class="bg-dark text-center py-5">
        <div class="container px-5">
            <div class="text-white-50 small">
                <div class="mb-2">Powered by <a href="https://netvideo.tv/">Netvideo</a></div>
                <!-- <a href="#!">No de ITEM Registro: 118599</a>
                <span class="mx-1">&middot;</span>
                <a href="#!">No de ITEM Página: 118701</a>
                <span class="mx-1">&middot;</span>
                <a href="#!">No de ITEM Página: 118701</a> -->
            </div>
        </div>
    </footer>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'Footer',
    data() {
        return {
            logo_file: null,
        }
    },
    mounted() {
        
    },
})
</script>
<style lang="scss" scoped>
@import '../../styles/app';

footer a {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
}
footer a:hover, footer a:active, footer a:focus {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: underline;
}

</style>